$mol_hint $mol_check
	dictionary *
	Icon $mol_icon_help_circle_outline
	hint_close @ \Hide
	hint_open @ \Hint
